import { render, staticRenderFns } from "./productAdd2.vue?vue&type=template&id=af591af2&"
import script from "./productAdd2.vue?vue&type=script&lang=js&"
export * from "./productAdd2.vue?vue&type=script&lang=js&"
import style0 from "./productAdd2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports